var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("label", [_vm._v(_vm._s(_vm.label))]),
      _vm._v(" "),
      _vm.routeLabel
        ? _c(
            "AtTCCheckbox",
            _vm._b(
              {
                attrs: { "route-label": _vm.routeLabel, to: _vm.to },
                on: {
                  input: function ($event) {
                    return _vm.$emit("input", $event)
                  },
                },
              },
              "AtTCCheckbox",
              _vm.$attrs,
              false
            )
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }